import React from 'react';
import { useTranslation } from 'react-i18next';
import { SmlsButton, SmlsModal } from '@smiles/smiles-ui-kit-react';
import { ModalBody, ModalFooter } from 'reactstrap';
import { TangModalHeader } from '../components/TangModalHeader';
import { LoginModal, useLoginModalFlow } from '../context/LoginModalFlowContext';
import { ImageModalWhiteSimpleCellphoneAndCircle } from '../assets/ImageModalWhiteSimpleCellphoneAndCircle';


export function BlockAkamaiPassErrorModal() {
  const { t } = useTranslation('modais');
  const modalFlow = useLoginModalFlow();

  function toggleModal() {
    modalFlow.closeModal(LoginModal.BLOCK_AKAMAI_INPUT_PASS)
  }
  
  return (
    <SmlsModal
      type="right"
      isOpen={modalFlow.isModalOpen(LoginModal.BLOCK_AKAMAI_INPUT_PASS)}
      className="tang-modal"
      toggle={toggleModal}
      defaultHeader={false}
    >
      <TangModalHeader showCloseButton onClose={toggleModal} />
      <ModalBody data-testid="modal-body">
        <div className="modal-content">
          <div> 
            <div className="modal-icon">
              <ImageModalWhiteSimpleCellphoneAndCircle />
            </div>
            <p className="modal-title">{t('block_akamai_input_pass.title')}</p>
            <p className="modal-subtitle">
              {t('block_akamai_input_pass.text')}
            </p>
          </div>
        </div>
      </ModalBody>
      <ModalFooter className='one-button'>
        <SmlsButton className="button" text={t('block_akamai_input_pass.button')} onClick={toggleModal} />
      </ModalFooter>
    </SmlsModal>
  );
}
